import React, { useContext } from "react";
import {
  ListItemText,
  ListItemIcon,
  ListItemButton,
  List,
  ListSubheader,
  Divider,
  Paper,
  ThemeProvider,
  //createTheme,
  //useTheme,
} from "@mui/material";
import {
  Dashboard,
  NotificationsActive,
  NotificationsOff,
  PieChart,
  Settings,  
  VolumeOff,
  VolumeUp,
} from "@mui/icons-material";
import { MainLayOutContect } from "./MainLayout";
//import g1 from "../src/images/Group31.png";
//import g2 from "../src/images/Group21.png";

import { darkTheme } from "./App";

function MenuBar() {
  const {
    togleCollapse,
    isMenu,
    setIsMenu,
    notificationSwitch,
    setNotificationSwitch,
    soundSwitch,
    setSoundSwitch,
  } = useContext(MainLayOutContect);
  return (
    <ThemeProvider theme={darkTheme}>
      <Paper
        sx={{
          overflowY: "auto",
          overflowX: "hidden",
          px: 1,
          borderTop: 0,
          borderLeft: 0,
          borderBottom: 0,
          borderRadius: 0,
          maxWidth: togleCollapse ? 280 : 65,
          minWidth: togleCollapse ? 280 : 65,
          transition: "all 0.2s ease-in-out",
        }}
      >
        <List
          sx={{
            width: "100%",
          }}
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            togleCollapse && (
              <ListSubheader
                sx={{
                  backgroundColor: "transparent",
                }}
                component="div"
                id="nested-list-subheader"
              >
                Main Menu
              </ListSubheader>
            )
          }
        >
          <ListItemButton
            sx={{ borderRadius: 2, px: 1.5 }}
            selected={isMenu === 0}
            onClick={() => setIsMenu(0)}
          >
            <ListItemIcon>
              <Dashboard />
            </ListItemIcon>
            {togleCollapse && (
              <ListItemText
                className="animate__animated animate__jackInTheBox"
                sx={{ whiteSpace: "nowrap" }}
                primary="Dashboard"
              />
            )}
          </ListItemButton>
          <ListItemButton
            sx={{ borderRadius: 2, px: 1.5 }}
            selected={isMenu === 1}
            onClick={() => setIsMenu(1)}
          >
            <ListItemIcon>
              <Settings />
            </ListItemIcon>
            {togleCollapse && (
              <ListItemText
                className="animate__animated animate__slideInRight"
                sx={{ whiteSpace: "nowrap" }}
                primary="Configurations"
              />
            )}
          </ListItemButton>
        </List>
        <Divider />
        <List
          sx={{
            width: "100%",
          }}
          component="nav"
          aria-labelledby="nested-list-subheader2"
          subheader={
            togleCollapse && (
              <ListSubheader
                sx={{
                  backgroundColor: "transparent",
                  //color: theme.palette.mode === "dark" ? null : "#FFFFFFB3",
                }}
                component="div"
                id="nested-list-subheader2"
              >
                Analytics
              </ListSubheader>
            )
          }
        >
          <ListItemButton
            sx={{ borderRadius: 2, px: 1.5 }}
            onClick={() => setIsMenu(2)}
          >
            <ListItemIcon>
              <PieChart />
            </ListItemIcon>
            {togleCollapse && (
              <ListItemText
                className="animate__animated animate__zoomInLeft"
                sx={{ whiteSpace: "nowrap" }}
                primary="Reports"
              />
            )}
          </ListItemButton>
        </List>
        <Divider />
        <List
          sx={{
            width: "100%",
          }}
          component="nav"
          aria-labelledby="nested-list-subheader2"
          subheader={
            togleCollapse && (
              <ListSubheader
                sx={{
                  backgroundColor: "transparent",
                }}
                component="div"
                id="nested-list-subheader2"
              >
                Settings
              </ListSubheader>
            )
          }
        >
          <ListItemButton
            sx={{ borderRadius: 2, px: 1.5 }}
            onClick={() => setNotificationSwitch(!notificationSwitch)}
          >
            <ListItemIcon>
              {notificationSwitch ? <NotificationsActive /> : <NotificationsOff />}
            </ListItemIcon>
            {togleCollapse && (
              <ListItemText
                className="animate__animated animate__bounce"
                sx={{ whiteSpace: "nowrap" }}
                primary="Notifications"
              />
            )}
          </ListItemButton>

          <ListItemButton
            sx={{ borderRadius: 2, px: 1.5 }}
            disabled={!notificationSwitch}
            onClick={() => setSoundSwitch(!soundSwitch)}
          >
            <ListItemIcon>
              {soundSwitch ? <VolumeUp /> : <VolumeOff />}
            </ListItemIcon>
            {togleCollapse && (
              <ListItemText
                className="animate__animated animate__backInRight"
                sx={{ whiteSpace: "nowrap" }}
                primary="Sound"
              />
            )}
          </ListItemButton>
        </List>
      </Paper>
    </ThemeProvider>
  );
}

export default MenuBar;
